import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  displayName: string;
}

export function DeleteFollowerSuccessToast(props: Props) {
  const {
    id, displayName,
  } = props

  const polyglot = usePolyglot()

  const body = polyglot.t(
    "toasts.remove_follower_success.body",
    {
      displayName,
    },
  )

  return (
    <Toast
      stylePreset="success"
      body={body}
      id={id}
    />
  )
}
